var Base64 = require('Base64');

module.exports = function (str) {
  var output = str.replace(/-/g, "+").replace(/_/g, "/");

  switch (output.length % 4) {
    case 0:
      break;

    case 2:
      output += "==";
      break;

    case 3:
      output += "=";
      break;

    default:
      throw "Illegal base64url string!";
  }

  var result = Base64.atob(output);

  try {
    return decodeURIComponent(escape(result));
  } catch (err) {
    return result;
  }
};